import { API_BASE_URL } from "../config/api";

const clearSession = () => {
  ["access", "authCredentials", "refresh", "role", "email"].forEach((key) => localStorage.removeItem(key));
};

export default async function fetchWithAuthRefresh(url, options = {}, navigate) {
  const send = () => fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
      Authorization: `Bearer ${localStorage.getItem("access")}`,
    },
  });
  let response = await send();
  if (response.status !== 401) return response;
  const refreshed = await fetch(`${API_BASE_URL}auth/trader/jwt/refresh/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh: localStorage.getItem("refresh") }),
  });
  if (!refreshed.ok) {
    clearSession();
    navigate?.("/signin");
    return null;
  }
  localStorage.setItem("access", (await refreshed.json()).access);
  return send();
}
